// src/pages/GramsevakServiceBook.js
import React from "react";

const GramsevakServiceBook = () => {


  const gramPanchayat = {
    name: "कोतवालबर्डी ग्रामपंचायत",
    taluka: "काटोल",
    district: "नागपूर",
    pincode: "441102",
    area: "४९०.५७ हेक्टर",
    contact: "9764850450",
    email: "kotawalbardi.panchayat@maharashtra.gov.in",
    website: "pnchayats.maharashtra.gov.in",
  };

  const gramsevak = {
    name: "श्री. शुद्धोधन भोजराज भोतमांगे",
    designation: "ग्राम विकास अधिकारी (ग्रामसेवक)",
    currentPosting: "कोतवालबर्डी ग्रामपंचायत",
   
  };

  return (
    <div style={styles.container}>
      {/* ===== सरकारी हेडर (महाराष्ट्र लोगो स्टाइल) ===== */}
      <header style={styles.govHeader}>
        <div style={styles.emblem}>
          <div style={styles.ashokChakra}></div>
        </div>
        <div style={styles.govTitle}>
          <h1 style={styles.govName}>महाराष्ट्र शासन</h1>
          <h2 style={styles.dept}>ग्रामविकास विभाग | जिल्हा परिषद नागपूर</h2>
        </div>
      </header>

      {/* ===== मुख्य हेडर ===== */}
      <header style={styles.mainHeader}>
        <div style={styles.logo}>
          <div style={styles.logoCircle}>GP</div>
        </div>
        <div style={styles.title}>
          <h1 style={styles.gpName}>{gramPanchayat.name}</h1>
          <p style={styles.gpInfo}>
            तालुका: {gramPanchayat.taluka} | जिल्हा: {gramPanchayat.district} | पिनकोड: {gramPanchayat.pincode}
          </p>
         
        </div>
      </header>

      {/* ===== ग्रामपंचायत माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रामपंचायत माहिती</h2>
        <div style={styles.infoGrid}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>क्षेत्रफळ</span>
            <span style={styles.infoValue}>{gramPanchayat.area}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>संपर्क</span>
            <span style={styles.infoValue}>{gramPanchayat.contact}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>ई-मेल</span>
            <span style={styles.infoValue}>{gramPanchayat.email}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>वेबसाइट</span>
            <a href={`https://${gramPanchayat.website}`} target="_blank" rel="noopener noreferrer" style={styles.link}>
              {gramPanchayat.website}
            </a>
          </div>
        </div>
      </section>

      {/* ===== ग्रामसेवक माहिती ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>ग्रामसेवक / ग्रा.वि.अ. वैयक्तिक माहिती</h2>
        <div style={styles.infoGrid}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>नाव</span>
            <span style={styles.infoValue}>{gramsevak.name}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>पद</span>
            <span style={styles.infoValue}>{gramsevak.designation}</span>
          </div>
          
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>सध्याची पोस्टिंग</span>
            <span style={styles.infoValue}>{gramsevak.currentPosting}</span>
          </div>
        </div>
      </section>

      {/* ===== कर्तव्ये ===== */}
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>मुख्य कर्तव्ये</h2>
        <ul style={styles.dutyList}>
          <li>ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li>कर वसुली, पाणीपट्टी, स्वच्छता शुल्क</li>
          <li>मनरेगा, स्वच्छ भारत, PMAY योजनांची अंमलबजावणी</li>
          <li>जन्म-मृत्यू, लग्न नोंदणी</li>
          <li>ग्रामपंचायत अभिलेख (नमुना १ ते ३३) ठेवणे</li>
        </ul>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <div style={styles.footerLine}></div>
        <p style={styles.footerText}>
          ही सेवा पुस्तिका <strong>महाराष्ट्र नागरी सेवा (सेवा पुस्तिका) नियम १९८१</strong> नुसार तयार केली आहे.
        </p>
        <p style={styles.copyright}>© २०२५ जिल्हा परिषद नागपूर | ग्रामविकास विभाग</p>
      </footer>
    </div>
  );
};

// ====== जोरदार Internal CSS (Standard & Professional) ======
const styles = {
  container: {
    fontFamily: "'Noto Sans Devanagari', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "950px",
    margin: "15px auto",
    padding: "30px",
    background: "#fafafa",
    border: "3px solid #1b5e20",
    borderRadius: "18px",
    boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    color: "#1a1a1a",
    lineHeight: "1.7",
  },

  // सरकारी हेडर
  govHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #ff9933, #ffffff, #138808)",
    padding: "18px",
    borderRadius: "14px 14px 0 0",
    margin: "-30px -30px 25px -30px",
    color: "blue",
    textAlign: "center",
    boxShadow: "inset 0 2px 8px rgba(0,0,0,0.2)",
  },
  emblem: {
    width: "60px",
    height: "60px",
    background: "#ffffff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "15px",
    boxShadow: "0 0 15px rgba(0,0,0,0.3)",
  },
  ashokChakra: {
    width: "40px",
    height: "40px",
    background: "radial-gradient(circle, #000080 10%, transparent 10%), radial-gradient(circle, #000080 10%, transparent 10%)",
    backgroundSize: "10px 10px",
    backgroundPosition: "0 0, 5px 5px",
    borderRadius: "50%",
    border: "2px solid #000080",
  },
  govTitle: {
    flex: 1,
  },
  govName: {
    margin: 0,
    fontSize: "22px",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
  dept: {
    margin: "4px 0 0 0",
    fontSize: "15px",
    fontWeight: "500",
  },

  // मुख्य हेडर
  mainHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    padding: "20px",
    background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
    borderRadius: "14px",
    border: "2px solid #81c784",
    boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
  },
  logo: {
    marginRight: "20px",
  },
  logoCircle: {
    width: "85px",
    height: "85px",
    background: "#2e7d32",
    color: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    fontWeight: "bold",
    boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
  },
  title: {
    flex: 1,
  },
  gpName: {
    margin: "0 0 8px 0",
    fontSize: "30px",
    color: "#1b5e20",
    fontWeight: "bold",
    letterSpacing: "0.5px",
  },
  gpInfo: {
    margin: "0 0 6px 0",
    fontSize: "17px",
    color: "#2e7d32",
    fontWeight: "600",
  },
  update: {
    margin: 0,
    fontSize: "14px",
    color: "#d32f2f",
    fontWeight: "bold",
  },

  // कार्ड
  card: {
    background: "white",
    padding: "25px",
    borderRadius: "14px",
    marginBottom: "25px",
    border: "1px solid #a5d6a7",
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    color: "#1b5e20",
    fontSize: "22px",
    fontWeight: "bold",
    margin: "0 0 18px 0",
    paddingBottom: "10px",
    borderBottom: "3px solid #81c784",
    letterSpacing: "0.5px",
  },

  // माहिती ग्रिड
  infoGrid: {
    display: "grid",
    gap: "14px",
  },
  infoRow: {
    display: "flex",
    background: "#f1f8e9",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #c5e1a5",
  },
  infoLabel: {
    background: "#81c784",
    color: "white",
    padding: "12px 16px",
    fontWeight: "bold",
    width: "45%",
    fontSize: "15px",
  },
  infoValue: {
    padding: "12px 16px",
    background: "#f9fbe7",
    flex: 1,
    fontSize: "15px",
    color: "#1b5e20",
    fontWeight: "500",
  },
  link: {
    color: "#2e7d32",
    textDecoration: "none",
    fontWeight: "600",
    padding: "12px 16px",
    background: "#f9fbe7",
    display: "block",
    flex: 1,
  },

  // कर्तव्ये
  dutyList: {
    paddingLeft: "22px",
    fontSize: "15.5px",
    lineHeight: "1.9",
    color: "#1a1a1a",
  },

  // फूटर
  footer: {
    textAlign: "center",
    paddingTop: "30px",
    marginTop: "20px",
  },
  footerLine: {
    height: "2px",
    background: "linear-gradient(to right, transparent, #81c784, transparent)",
    marginBottom: "15px",
  },
  footerText: {
    fontSize: "15px",
    color: "#2e7d32",
    margin: "8px 0",
    fontWeight: "500",
  },
  copyright: {
    fontSize: "13px",
    color: "#666",
    marginTop: "10px",
  },
};

export default GramsevakServiceBook;